<template>
  <div class="customize-form-cascader-mobile">
    <v-field
      v-model="fieldValue"
      class="customize-form-cascader-field"
      is-link
      readonly
      :placeholder="placeholder"
      @click="showCascaderPopup"
    />
    <v-popup v-model="popupShow" class="customize-form-cascader-popup" round position="bottom">
      <v-cascader
        class="customize-form-cascader-cascader"
        :value="innerValue"
        :title="placeholder"
        :options="options"
        :field-names="fieldNames"
        @close="hideCascaderPopup"
        @finish="onSelect"
      />
    </v-popup>
  </div>
</template>

<script>
import { getJSONString } from '../utils';

export default {
  name: 'CustomizeFormCascaderM',
  props: {
    value: Array,
    placeholder: String,
    options: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    this.fieldNames = {
      text: 'label',
    };

    return {
      fieldValue: '',
      innerValue: '',
      popupShow: false,
    };
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val, prevVal) {
        if (getJSONString(val) !== getJSONString(prevVal)) {
          this.setValue(val, this.options);
        }
      },
    },

    options: {
      deep: true,
      immediate: true,
      handler(val, prevVal) {
        if (getJSONString(val) !== getJSONString(prevVal)) {
          this.setValue(this.value, val);
        }
      },
    },
  },

  methods: {
    onInput(val) {
      this.$emit('input', [...val]);
    },

    onSelect({ selectedOptions }) {
      this.hideCascaderPopup();
      const fields = [];
      const values = [];
      selectedOptions.forEach((option) => {
        fields.push(option.label);
        values.push(option.value);
      });
      this.fieldValue = fields.join(' / ');
      this.onInput(values);
    },

    showCascaderPopup() {
      this.popupShow = true;
    },

    hideCascaderPopup() {
      this.popupShow = false;
    },

    setValue(values, options) {
      const value = values || [];
      const hasName = /[\u4e00-\u9fa5]/.test(value[0]);
      let lastValCode = value[value.length - 1];

      if (hasName) {
        lastValCode = this.getFormatLastCode([...value], options);
      }

      this.innerValue = lastValCode;
      this.setFieldValue(value, hasName, options);
    },

    setFieldValue(values, setDirectly, options) {
      if (setDirectly) {
        this.fieldValue = values.join(' / ');
        return;
      }

      const fieldValue = [];

      for (const val of values) {
        for (const option of options) {
          if (val === option.value) {
            options = option.children;
            fieldValue.push(option.label);
            break;
          }
        }
      }

      this.fieldValue = fieldValue.join(' / ');
    },

    getFormatLastCode(values, options) {
      let fieldValue = '';

      for (const val of values) {
        for (const option of options) {
          if (val === option.label) {
            options = option.children;
            fieldValue = option.value;
            break;
          }
        }
      }

      return fieldValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.customize-form-cascader {

  &-mobile {
    width: 100%;
  }
  
  &-field {
    padding: 7px 15px;
    color: var(--customize-form-text-color);
    border: 1px solid var(--customize-form-border-color);
    border-radius: var(--customize-form-border-radius);
    background-color: var(--customize-form-bg-color);

    ::v-deep {
      .van-field__control {
        &::placeholder {
          color: var(--customize-form-placeholder-color);
          font-size: var(--customize-form-title-font-size);
          font-weight: var(--customize-form-title-font-weight);
        }
      }
      .van-cell__right-icon {
        color: var(--customize-form-placeholder-color);
        font-size: var(--customize-form-text-font-size);
        transform: scale(1.05);
      }
      .van-field__control {
        color: var(--customize-form-text-color);
        font-size: var(--customize-form-text-font-size);
        font-weight: var(--customize-form-text-font-weight);
      }
    }
  }

  &-popup {
    ::v-deep {
      .van-cascader__title {
        color: var(--customize-form-title-color);
        font-size: var(--customize-form-title-font-size);
        transform: scale(1.08);
        transform-origin: left center;
      }
      .van-tabs__line {
        background-color: var(--customize-form-primary-color);
      }
      .van-tab {
        font-size: var(--customize-form-text-font-size);
      }
      .van-cascader__option {
        color: var(--customize-form-text-color);
        font-size: var(--customize-form-text-font-size);
        font-weight: var(--customize-form-text-font-weight);
      }
      .van-cascader__option--selected {
        color: var(--customize-form-primary-color);
      }
      .van-cascader__selected-icon {
        font-size: var(--customize-form-text-font-size);
        transform: scale(1.2);
      }
      .van-cascader__tab {
        color: var(--customize-form-title-color);
        font-size: var(--customize-form-title-font-size);
        font-weight: var(--customize-form-title-font-weight);
      }
    }
  }
}
</style>